<template>

    <v-container>

    
        <v-row justify = "center">
    
            <v-card class="mt-8 elevation-23">
                <v-carousel width="700">
                    <div class="display-3" align="center">Procesos de Transformación</div>
                    <v-sheet height="100%">
                        <v-row class="fill-height" align="center" justify="center">
                        </v-row>
                    </v-sheet>
                        <v-carousel-item 
                        v-for="(item,i) in items"
                        :key="i"
                        :src="item.src"
                        reverse-transition="fade-transition"
                        transition="fade-transition">       
                    </v-carousel-item>
                </v-carousel>          
            </v-card>
        </v-row>
    </v-container>
</template>
<script>
  export default {
    data () {
      return {
        items: [
          {
            //id:001,
            src: 'https://www.residuosprofesional.com/wp-content/uploads/2020/01/recuperacion-papel-cart%C3%B3n-768x486.jpg', 
          },
          {
            //id:002,
            src:'https://www.residuosprofesional.com/wp-content/uploads/2020/03/papel-para-reciclar.jpg', 
          },
          {
            //id:003,
            src:'https://picvisa.com/wp-content/uploads/2020/09/reciclaje-papel-carton-fibra.jpg',
          },
          {
              //id:004,
            src:'https://www.residuosprofesional.com/wp-content/uploads/2020/07/papel-y-cart%C3%B3n-recuperado-768x575.jpg',
          },
          {
              //id:005
            src:'https://emagen.com.mx/wp-content/uploads/2017/10/reciclaje-del-papel-2.jpg',
          },
          {
              //id:006
           src:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVlrDcXnhVcn9xgqqb8lNXMbul_7W1MD6v2rAMiQe8L6B6f22uktLwky-gxLVclbn3WWA&usqp=CAU',
          },
          {
              //id:007
          src:'https://climaticocambio.com/wp-content/2012/02/Reciclar-papel-disminuye-las-emisiones-de-CO2.jpg',
          },
          {
              //id:008
          src:'https://recsa-ecologic.com/wp-content/uploads/2018/11/Reciclado-de-papel-y-plastico-300x225.jpg',

          },
          {
              //id:009
          src:'https://envira.es/wp-content/uploads/1900/01/environment-2196690_640.jpg',
          },
          {
              //id:010
          src:'https://1.bp.blogspot.com/-jzxgrsHCwmk/Xs2UVTr8idI/AAAAAAAAOQs/2PUo9rzaBi46cPg1PoqXKYwau_XmLkFrQCLcBGAsYHQ/s1600/reciclaje-de-papel-recoleccion-almacenaje.jpg',
          },
          {
              //id:011
         src:'https://www.neobis.es/wp-content/uploads/2017/09/Reciclaje-004.jpg',
          },
          {
              //id:012
          src:'https://1.bp.blogspot.com/-nA6zdwOpMe8/Xs2T1bcbAzI/AAAAAAAAOQc/bcAYkmVQkQM9rGTYunw2GiCZPMJpDDuIACLcBGAsYHQ/s1600/reciclaje-de-papel-planta-recicladora.jpg',
          },
          {
              //id:013
          src:'http://coparm.es/wp-content/uploads/2015/04/home_new-19.jpg',

          },
          {
              //id:014
          src:'https://www.rajapack.es/blog-es/wp-content/uploads/2015/06/reciclado_carton_C.jpg',
          },
          {
              //id:015
          src:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQE-WVHgV6sBv9NbJsSWtRsfyzXAGJsdSoKoQ&usqp=CAU',
          },
          {
              //id:016
          src:'https://lh3.googleusercontent.com/proxy/ipQwJpwP7VF57T_P5I06p0rwMNr4wcjP8r5TOJev4TnSJQ9fAW1mmd_vdPo05x0uXmEmuK6VK-iHFuhgbJcbgVN7kpS3cCr_RPNGl8jqSFRfW8l1GWM5ynchdrjsIvpoTXvZ',
          },

      ],
      //transparent: 'rgba(255, 255, 255, 0)',
      }
   },
  }

</script>


<style>

</style>